import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import configureStore from "../src/store";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import "bootstrap/dist/css/bootstrap.min.css";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./utils/authConfig";
import "./index.css";
import "./scss/custom.scss";
import App from "./containers/App";

// Check if this is a Clever IdP flow BEFORE Redux Persist loads
const urlParams = new URLSearchParams(window.location.search);
const isCleverIdpLoginInitial = urlParams.get("idp") === "clever";
const hasHashResponse = window.location.hash.includes("id_token");

// Only clear session if this is the INITIAL Clever redirect (no hash yet)
// If hash exists, it means B2C already responded with a token - don't clear it!
if (isCleverIdpLoginInitial && !hasHashResponse) {
  console.log("Clever IdP detected on initial load, forcing session clear");
  // Clear persisted state to ensure clean session
  localStorage.clear();
  sessionStorage.clear();
  localStorage.removeItem("persist:root");
  localStorage.setItem("idp", "clever");
} else if (isCleverIdpLoginInitial && hasHashResponse) {
  console.log("Clever IdP with B2C response detected, preserving token");
  // Only set the idp flag, don't clear anything
  localStorage.setItem("idp", "clever");
}

const msalInstance = new PublicClientApplication(msalConfig);
const persistor = persistStore(configureStore);
ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <Provider store={configureStore}>
      <PersistGate persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </MsalProvider>,
  document.querySelector("#root")
);
